// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 66 ? "dc112a36" : chunkId) + "." + {"66":"2182f4687466b575","770":"6d4fa5ec3ef74c0e"}[chunkId] + ".js";
};